document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('form[data-variants]');
  if (!forms.length) return;

  forms.forEach(function(form) {
    var variantIds, variantOptions, variantAvailability;
    try {
      variantIds = JSON.parse(form.dataset.variants || '[]');
      variantOptions = JSON.parse(form.dataset.options || '[]');
      variantAvailability = JSON.parse(form.dataset.availability || '{}');
    } catch (e) {
      return;
    }
    const addToCartBtn = form.querySelector('.add-to-cart');

    function updateVariantId() {
      const selectedOptions = [];
      // Obtener todos los radios seleccionados
      const checkedRadios = form.querySelectorAll('input[type=radio]:checked');
      checkedRadios.forEach((radio) => {
        selectedOptions.push(radio.value.trim());
      });
      // Obtener todos los selects
      const selects = form.querySelectorAll('select');
      selects.forEach((select) => {
        selectedOptions.push(select.value.trim());
      });
      const matchingVariantIndex = variantOptions.findIndex((variantOpts) => {
        return variantOpts.every((opt, i) => opt === selectedOptions[i]);
      });
      if (matchingVariantIndex !== -1) {
        const variantId = variantIds[matchingVariantIndex];
        const variantInput = form.querySelector('.product-variant-id');
        if (variantInput) {
          variantInput.value = variantId;
        }
        if (addToCartBtn) {
          const isAvailable = variantAvailability[variantId];
          const anyAvailable = Object.values(variantAvailability).some(Boolean);
          const preOrderLabel = form.dataset.preOrderLabel || '';
          const addToCartLabel = form.dataset.addToCartLabel || '';
          const selectSizeLabel = form.dataset.selectSizeLabel || '';
          const soldOutLabel = form.dataset.soldOutLabel || '';
          const addLabel = form.dataset.preOrderDate ? preOrderLabel : addToCartLabel;
          if (isAvailable) {
            addToCartBtn.classList.remove('sold-out');
            addToCartBtn.textContent = addLabel;
            addToCartBtn.disabled = false;
          } else {
            addToCartBtn.classList.add('sold-out');
            addToCartBtn.textContent = anyAvailable ? selectSizeLabel : soldOutLabel;
            addToCartBtn.disabled = true;
          }
        }
      } else {
        console.warn('No matching variant for:', selectedOptions);
      }
    }

    function updateImagesByColor(selectedColorValueFromInput) {
      const colorIndex = form.getAttribute('data-color-option-index');
      if (colorIndex == null) return;
      const productContainer = form.closest('#product-container');
      if (!productContainer) return;
      const mediaContainer = productContainer.querySelector('#product-media-container');
      if (!mediaContainer) return;
      const images = mediaContainer.querySelectorAll('.variant-product-image');
      if (!images.length) return;

      var selectedColorValue = selectedColorValueFromInput;
      if (selectedColorValue == null && form.dataset.options && form.dataset.variants) {
        var variantIdInput = form.querySelector('.product-variant-id');
        if (variantIdInput) {
          try {
            var variantIds = JSON.parse(form.dataset.variants);
            var variantOptions = JSON.parse(form.dataset.options);
            var currentId = variantIdInput.value;
            var matchIndex = variantIds.indexOf(parseInt(currentId, 10));
            if (matchIndex === -1) {
              matchIndex = variantIds.indexOf(currentId);
            }
            if (matchIndex !== -1 && variantOptions[matchIndex]) {
              var idx = parseInt(colorIndex, 10) - 1;
              selectedColorValue = variantOptions[matchIndex][idx];
            }
          } catch (err) {}
        }
      }
      if (selectedColorValue == null) return;
      var optionHandle = String(selectedColorValue).trim().replace(/\s+/g, '-').toLowerCase();

      images.forEach(function (el) {
        var color = (el.getAttribute('data-color') || '').replace(/\s+/g, '-').toLowerCase();
        if (color === optionHandle) {
          el.classList.remove('hide');
          el.classList.add('show');
        } else {
          el.classList.add('hide');
          el.classList.remove('show');
        }
      });

      if (window.productMediaSwiper) {
        var swiper = window.productMediaSwiper;
        var wrapper = mediaContainer.querySelector('.swiper-wrapper');
        var slides = wrapper ? wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)') : [];
        if (slides.length === 0 && wrapper) {
          slides = wrapper.querySelectorAll('.swiper-slide');
        }
        var firstVisibleIndex = 0;
        for (var i = 0; i < slides.length; i++) {
          if (!slides[i].classList.contains('hide')) {
            firstVisibleIndex = i;
            break;
          }
        }
        swiper.update();
        swiper.slideTo(firstVisibleIndex, 0);
        requestAnimationFrame(function () {
          swiper.update();
          swiper.slideTo(firstVisibleIndex, 0);
        });
      }
    }

    form.addEventListener('change', function (e) {
      if (
        e.target.matches('input[type=radio]') ||
        e.target.matches('select')
      ) {
        updateVariantId();
        var colorFieldset = form.querySelector('.product-option[data-color-option]');
        var isColorChange = colorFieldset && colorFieldset.contains(e.target);
        if (isColorChange && e.target.matches('.product-variant-input') && e.target.checked) {
          colorFieldset.querySelectorAll('.product-color-swatch-item--image').forEach(function (item) {
            item.classList.toggle('active-swatch', item.contains(e.target));
          });
          var colorLabel = colorFieldset.querySelector('[data-variant-color-label]');
          if (colorLabel) {
            colorLabel.textContent = e.target.value.toLowerCase();
          }
        }
        if (isColorChange && e.target.checked) {
          updateImagesByColor(e.target.value);
        } else {
          requestAnimationFrame(function () {
            updateImagesByColor();
          });
        }
      }
    });

    updateVariantId();
    requestAnimationFrame(function () {
      updateImagesByColor();
    });
  });
});